.btn {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
}

/* Палочка чуть приподнимается на наведении — единственный намёк на то, что
   кнопка не такая, как соседние. Цвет при этом обычный, кнопочный. */
.icon {
  flex: 0 0 auto;
  transition: transform var(--dnd-dur) var(--dnd-ease);
}

.btn:hover .icon,
.btn:focus-visible .icon {
  transform: rotate(-12deg) scale(1.08);
}

@media (prefers-reduced-motion: reduce) {
  .icon {
    transition: none;
  }

  .btn:hover .icon,
  .btn:focus-visible .icon {
    transform: none;
  }
}
